// DS: MO 4.1.6
import React from 'react';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import {
  BiContextProvidedValue,
  BiData,
  SellYourArtClickBiEvent,
} from '@wix/da-bi/pkg/events';
import ShopLogo from '@wix/da-ds/pkg/ShopLogo';
import BuyButton from '@wix/da-ds/pkg/Buttons/BuyButton';
import DeviationPromo from '../DeviationPromo';
import { useSellAction } from '../exclusives/hooks';

interface Props {
  deviation: PapiDeviation;
}

const ShopPromo: React.FC<Props> = ({ deviation }) => {
  const { t } = useTranslation();

  // We don't use the hook's biData, we have our own
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [sellAction, _] = useSellAction(deviation);

  return (
    <DeviationPromo
      deviation={deviation}
      onClick={sellAction}
      biData={BiData<SellYourArtClickBiEvent>({
        evid: 353,
        deviationid: deviation.deviationId,
        sectionname: BiContextProvidedValue,
      })}
      heading={t('sidebar.shopPromo.heading')}
      subheading={t('sidebar.shopPromo.description')}
      attributionSlot={deviation && t('sidebar.shopPromo.attribution')}
      logoSlot={<ShopLogo />}
      ctaSlot={(
        <BuyButton rounded size="medium" variant="solid">
          {t('sidebar.shopPromo.sellCta')}
        </BuyButton>
      )}
    />
  );
};

ShopPromo.displayName = 'ShopPromo';

export default ShopPromo;
